// 草图输入框--用于草图绘制时的X、Y坐标输入

import {
  modifyGridLength,
  enableSnapCorrection,
} from "@/rlMxModules/operate/operateApi";
import store from "@/store";
import { McGePoint3d } from "mxcad";
import { Message } from "element-ui";
import { saveDatabaseStore } from "@/rlMxModules/operate/operateApi";
import { isMobileDevice } from "@/utils/matchMedia.js";
import { drawAxisSketch } from "@/rlMxModules/rlDataClass/DrawAxis.js"; // 导入绘制线条方法
import {
  checkSketchLength,
  getSketchLineGroup,
  checkInputDataLength,
  filterRepeatErrorLine,
  checkSketchLineLength,
} from "@/views/inspectionLite/components/ModulePage/utils/sketch.js";
import { isNumber } from "xe-utils";
let sketchInputContainer = null; // 容器元素
let sketchInputElementX = null; // X坐标输入框
let sketchInputElementY = null; // Y坐标输入框
let currSketchDataObj = null; // 输入框数据对应的对象
let bSketchGoOn = true; // 是否继续执行
let sketchOtherData = {}; // 用于存放传进来的任何参数
let sketchInputLabelX = null; // X坐标提示语label元素
let sketchInputLabelY = null; // Y坐标提示语label元素
let isSketchInputElementVisible = false; // 用于跟踪输入框显示状态

// 获取输入框
export const getSketchInputElement = () => {
  if (!sketchInputElementX || !sketchInputElementY) {
    return null;
  }
  return sketchInputContainer;
};

// 获取输入框当前对应的对象
export const getSketchCurrDataObj = () => {
  return currSketchDataObj;
};

// 获取其他传进来的参数
export const getSketchOtherData = () => {
  return sketchOtherData;
};

const isMobile = isMobileDevice();

// 创建输入框
export const createSketchInputElement = (obj = null) => {
  currSketchDataObj = obj;
  if (sketchInputContainer)
    return { x: sketchInputElementX, y: sketchInputElementY };

  // 创建包装容器
  sketchInputContainer = document.createElement("div");
  sketchInputContainer.style.position = "absolute";
  sketchInputContainer.style.zIndex = "999";
  sketchInputContainer.style.display = "flex";
  sketchInputContainer.style.flexDirection = "row"; // 修改为水平排列
  sketchInputContainer.style.alignItems = "center"; // 垂直居中对齐
  sketchInputContainer.style.gap = "2px"; // 更小的间距
  sketchInputContainer.style.padding = "3px 5px"; // 添加内边距
  sketchInputContainer.style.background = "rgba(255, 255, 255, 0.9)"; // 半透明背景
  sketchInputContainer.style.borderRadius = "6px"; // 圆角边框
  sketchInputContainer.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.1)"; // 轻微阴影

  // 创建X坐标输入框容器
  const xContainer = document.createElement("div");
  xContainer.style.display = "flex";
  xContainer.style.alignItems = "center";

  // 创建Y坐标输入框容器
  const yContainer = document.createElement("div");
  yContainer.style.display = "flex";
  yContainer.style.alignItems = "center";

  // 创建+号分隔符
  const plusSign = document.createElement("div");
  plusSign.textContent = "+";
  plusSign.style.margin = "0 2px"; // 减小间距
  plusSign.style.fontSize = "14px"; // 减小字体
  plusSign.style.fontWeight = "bold";
  plusSign.style.color = "rgb(0, 0, 0)";

  // 创建X坐标输入框
  sketchInputElementX = document.createElement("input");
  sketchInputElementX.type = "number";
  sketchInputElementX.setAttribute("data-rl-keypad", "true");

  // 创建Y坐标输入框
  sketchInputElementY = document.createElement("input");
  sketchInputElementY.type = "number";
  sketchInputElementY.setAttribute("data-rl-keypad", "true");

  // 创建X坐标提示语label
  sketchInputLabelX = document.createElement("div");
  sketchInputLabelX.style.position = "relative";
  sketchInputLabelX.style.marginRight = "4px"; // 减小间距
  sketchInputLabelX.style.color = "#555";
  sketchInputLabelX.style.fontSize = "11px"; // 减小字体
  sketchInputLabelX.style.whiteSpace = "nowrap";
  sketchInputLabelX.style.display = "none";
  sketchInputLabelX.textContent = "X"; // 简化标签文本

  // 创建Y坐标提示语label
  sketchInputLabelY = document.createElement("div");
  sketchInputLabelY.style.position = "relative";
  sketchInputLabelY.style.marginRight = "4px"; // 减小间距
  sketchInputLabelY.style.color = "#555";
  sketchInputLabelY.style.fontSize = "11px"; // 减小字体
  sketchInputLabelY.style.whiteSpace = "nowrap";
  sketchInputLabelY.style.display = "none";
  sketchInputLabelY.textContent = "Y"; // 简化标签文本

  // 设置基本样式
  const setupInputStyle = (inputElement) => {
    inputElement.style.width = "60px"; // 减小宽度
    inputElement.style.height = "18px"; // 减小高度
    inputElement.style.border = "1px solid rgb(117, 193, 196)"; // 更细的边框
    inputElement.style.background = "linear-gradient(135deg, #f0f0f0, #fafafa)";
    inputElement.style.textAlign = "center";
    inputElement.style.display = "block";
    inputElement.style.zIndex = 999;
    inputElement.style.fontSize = "12px"; // 减小字体
    inputElement.autocomplete = "off"; // 关闭自动完成
    isMobile && (inputElement.style.userSelect = "none"); // 禁止全选
    inputElement.style.borderRadius = "4px"; // 更小的圆角
    inputElement.style.boxShadow = "0px 2px 5px rgba(0, 0, 0, 0.1)"; // 更轻微的阴影
    inputElement.style.color = "#333"; // 字体颜色
    inputElement.style.padding = "0 2px"; // 更小的内边距
  };

  setupInputStyle(sketchInputElementX);
  setupInputStyle(sketchInputElementY);

  // 创建样式表以隐藏数字输入框的上下箭头
  const style = document.createElement("style");
  style.innerHTML = `
/* 隐藏 Chrome, Safari, Edge 中的箭头 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 隐藏 Firefox 中的箭头 */
input[type="number"] {
  -moz-appearance: textfield;
}
`;
  document.head.appendChild(style);

  // 为X输入框添加事件监听
  setupInputEvents(sketchInputElementX);

  // 为Y输入框添加事件监听
  setupInputEvents(sketchInputElementY);

  // 将输入框和label添加到容器中
  xContainer.appendChild(sketchInputLabelX);
  xContainer.appendChild(sketchInputElementX);

  yContainer.appendChild(sketchInputLabelY);
  yContainer.appendChild(sketchInputElementY);

  sketchInputContainer.appendChild(xContainer);
  sketchInputContainer.appendChild(plusSign); // 添加+号分隔符
  sketchInputContainer.appendChild(yContainer);

  document.body.appendChild(sketchInputContainer);

  return { x: sketchInputElementX, y: sketchInputElementY };
};

// 设置输入框事件
const setupInputEvents = (inputElement) => {
  // 修改 focus 状态时的样式
  inputElement.addEventListener("focus", function () {
    inputElement.style.borderColor = "rgb(99, 163, 166)"; // 焦点时更深的蓝色边框
    inputElement.style.boxShadow = "0px 6px 20px rgba(0, 123, 255, 0.4)"; // 增强的阴影效果
    inputElement.style.background =
      "linear-gradient(135deg, rgb(225, 245, 246), #ffffff)"; // 焦点时的渐变背景
    if (!isMobile) {
      inputElement.select(); // 选中全部内容
    } else {
      inputElement.value = "";
      window.document.body.classList.add("mobile-main");
    }
  });

  // 当失去焦点时还原样式
  inputElement.addEventListener("blur", function () {
    inputElement.style.borderColor = "rgb(117, 193, 196)"; // 恢复默认蓝色边框
    inputElement.style.boxShadow = "0px 6px 15px rgba(0, 0, 0, 0.15)"; // 恢复阴影效果
    inputElement.style.background = "linear-gradient(135deg, #f0f0f0, #fafafa)"; // 恢复背景
    if (isMobile) {
      window.document.body.classList.remove("mobile-main");
    }
  });

  // 监听输入事件，确保输入内容为数字
  inputElement.addEventListener("input", function () {
    inputElement.value = inputElement.value.replace(/[^0-9.-]/g, ""); // 允许输入数字, 小数点和负号
  });

  // 监听键盘事件，检测到回车键时失去焦点
  inputElement.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      setSketchInputBlur(); // 失去焦点
    }
  });
};

// 修改输入框的位置及文本内容
export const setSketchInputElementPosition = (textX, textY, x, y) => {
  console.log("textX", textX);
  console.log("textY", textY);

  // 坐标转换
  const selectObjPoint = rlAppObj._rlMx.MxFun.cadCoord2Doc(x, y);
  // 将文档坐标转换为屏幕坐标
  const pxPoint = rlAppObj._rlMx.MxFun.docCoord2Screen(
    selectObjPoint.x,
    selectObjPoint.y
  );

  sketchInputElementX.value = Number(textX);
  sketchInputElementY.value = Number(textY);

  // 获取视窗尺寸
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  // 计算输入框应该放置的位置，确保不超出屏幕
  let leftPos = pxPoint.x;
  let topPos = pxPoint.y + 10;

  // 处理左右边界
  if (leftPos + sketchInputContainer.offsetWidth > viewportWidth) {
    leftPos = viewportWidth - sketchInputContainer.offsetWidth - 10; // 留10px边距
  }
  if (leftPos < 10) {
    leftPos = 10; // 至少距离屏幕左边10px
  }

  // 处理上下边界
  if (topPos + sketchInputContainer.offsetHeight > viewportHeight) {
    topPos = viewportHeight - sketchInputContainer.offsetHeight - 10; // 留10px边距
  }
  if (topPos < 10) {
    topPos = 10; // 至少距离屏幕顶部10px
  }

  // 应用计算后的位置
  sketchInputContainer.style.left = leftPos + "px";
  sketchInputContainer.style.top = topPos + "px";
};

// 设置输入框的显示状态及提示语
export const setSketchContainerShow = (
  inputElementShow,
  inputLabelXShow = false,
  inputLabelYShow = false,
  inputLabelXText = "",
  inputLabelYText = ""
) => {
  // 检查状态是否变化
  if (isSketchInputElementVisible !== inputElementShow) {
    isSketchInputElementVisible = inputElementShow;
    // 如果输入框隐藏，则清除多余线
    if (!isSketchInputElementVisible) {
      // 清除多余线
      clearSketchExtraLine();
    }
  }

  if (!inputElementShow) {
    if (sketchInputContainer) {
      sketchInputContainer.style.display = "none";
    }
    if (sketchInputLabelX) {
      sketchInputLabelX.style.display = "none";
      sketchInputLabelX.textContent = "";
    }
    if (sketchInputLabelY) {
      sketchInputLabelY.style.display = "none";
      sketchInputLabelY.textContent = "";
    }
  } else {
    if (sketchInputContainer) {
      sketchInputContainer.style.display = "flex";
      // 让第一个输入框获得焦点并全选内容
      if (!isMobile) {
        setTimeout(() => {
          sketchInputElementX.focus();
          sketchInputElementX.select();
        }, 0);
      }
    }
    if (sketchInputLabelX) {
      sketchInputLabelX.style.display = inputLabelXShow ? "block" : "none";
      sketchInputLabelX.textContent = inputLabelXText || "X坐标";
    }
    if (sketchInputLabelY) {
      sketchInputLabelY.style.display = inputLabelYShow ? "block" : "none";
      sketchInputLabelY.textContent = inputLabelYText || "Y坐标";
    }
  }
};

// 设置当前的对象
export const setSketchCurrDataObj = (obj) => {
  currSketchDataObj = obj;
  sketchInputElementX.readOnly = false;
  sketchInputElementY.readOnly = false;
};

// 设置其他传进来的参数
export const setSketchOtherData = (obj) => {
  sketchOtherData = obj;
};

// 清除其他传进来的参数
export const eraseSketchOtherData = () => {
  if (sketchOtherData) {
    if (sketchOtherData.mDimensionObj1) {
      sketchOtherData.mDimensionObj1.erase();
      sketchOtherData.mDimensionObj1 = null;
    }
    if (sketchOtherData.mDimensionObj2) {
      sketchOtherData.mDimensionObj2.erase();
      sketchOtherData.mDimensionObj2 = null;
    }
    if (sketchOtherData.polylineObj) {
      sketchOtherData.polylineObj.erase();
      sketchOtherData.polylineObj = null;
    }
  }
};

// 获取输入框数值
export const getSketchInputNum = () => {
  return {
    x: parseFloat(sketchInputElementX.value),
    y: parseFloat(sketchInputElementY.value),
  };
};

// 清除多余线方法
export const clearSketchExtraLine = (eraseOther = true) => {
  // 清除标注
  const mDimensionId = store.state.globalData.mDimensionId;

  if (mDimensionId) {
    mDimensionId.erase();
    store.commit("globalData/setmDimensionId", null);
  }

  // 检查并清除
  const dimensionObj = store.state.globalData.dimensionObj;
  if (dimensionObj) {
    dimensionObj.erase();
    store.commit("globalData/setDimensionObj", null);
  }

  // 清除当前轴线
  const currentMcDbId = store.state.globalData.currentMcDbId;
  if (currentMcDbId) {
    currentMcDbId.erase();
    store.commit("globalData/setCurrentMcDbId", null);
  }

  // 清除当前圆弧
  const currentArcMcDbId = store.state.globalData.currentArcMcDbId;
  if (currentArcMcDbId) {
    currentArcMcDbId.erase();
    store.commit("globalData/setCurrentArcMcDbId", null);
  }
  // 清除其他数据--输入框时的多余线
  if (eraseOther) eraseSketchOtherData();
};

// 设置输入框失焦
export const setSketchInputBlur = async () => {
  // 清除多余线
  clearSketchExtraLine(false);
  sketchInputElementX.readOnly = false;
  sketchInputElementY.readOnly = false;

  // 是否数据无效
  let isInvalid = false;

  if (
    !sketchInputElementX ||
    !sketchInputElementY ||
    !currSketchDataObj ||
    sketchInputContainer.style.display != "flex"
  ) {
    return;
  }

  let inputValueX = parseFloat(sketchInputElementX.value);
  let inputValueY = parseFloat(sketchInputElementY.value);

  console.log("inputValueX", inputValueX);
  console.log("inputValueY", inputValueY);

  // if (isNaN(inputValueX) || isNaN(inputValueY)) {
  //   Message.warning("输入数据无效，请重新输入!");
  //   sketchInputElementX.blur();
  //   sketchInputElementY.blur();
  //   setSketchContainerShow(false);
  //   isInvalid = true;
  // }
  inputValueX = isNaN(inputValueX) ? 0 : inputValueX;
  inputValueY = isNaN(inputValueY) ? 0 : inputValueY;

  if (currSketchDataObj && !isInvalid) {
    if (currSketchDataObj.classTypeName == "rlGridC") {
      //当长度是0时,用的又是通用厚度,不设置改0
      // inputValueY =
      //   inputValueX == 0 && inputValueY != currSketchDataObj.Thickness
      //     ? 0
      //     : inputValueY;

      // console.log("currSketchDataObj", currSketchDataObj);
      //检查草图线长度是否合理,tipsChildGroup是返回的长度有问题的草图数组
      await checkSketchLineLength(currSketchDataObj, inputValueX, inputValueY);
      //如果草图检查窗口已打开,更新草图检查窗口
      if (store.state.inspectionStore.sketchChangeErrorShow) {
        let gridCDistGroup = getSketchLineGroup();
        let { errorGridC, setLengthNum } = await checkSketchLength(
          gridCDistGroup
        ); //获取所有长度错误网格
        if (setLengthNum > 0) {
          while (setLengthNum > 0) {
            gridCDistGroup = [];
            gridCDistGroup = getSketchLineGroup();
            ({ errorGridC, setLengthNum } = await checkSketchLength(
              gridCDistGroup
            )); //获取所有长度错误网格
          }
        }
        gridCDistGroup = [];
        gridCDistGroup = getSketchLineGroup();
        let tipsGroup = checkInputDataLength(gridCDistGroup); //获取所有长度错误网格
        let errorDatas = filterRepeatErrorLine(errorGridC, tipsGroup);
        if (
          errorDatas.errorGridC.length != 0 ||
          errorDatas.tipsGroup.length != 0
        ) {
          store.commit("inspectionStore/setsketchChangeErrorData", {});
          store.commit("inspectionStore/setsketchChangeErrorData", errorDatas);
        } else {
          store.commit("inspectionStore/setsketchChangeErrorShow", false);
          store.commit("inspectionStore/setsketchChangeErrorData", {});
        }
      }
    }

    await saveDatabaseStore();
  }

  if (!isInvalid) {
    sketchInputElementX.blur();
    sketchInputElementY.blur();
    // 隐藏整个容器
    setSketchContainerShow(false);
  }

  // 更新标注重新绘制
  rlAppObj.rlMxDrawObject.updateDisplay();

  // 继续绘制草图
  if (
    store.state.inspectionStore.currentSketchType == "DrawSketch" &&
    store.state.inspectionStore.isInCommand &&
    currSketchDataObj?.classTypeName == "rlAxisC"
  ) {
    // 继续绘制轴线
    if (!store.state.app.isPcMode) {
      // 可选：为后续操作添加触摸事件监听
      let touchTimer = null;
      sketchTouchStartHandlerRef = (e) => touchHandler(e);
      const touchHandler = async (event) => {
        if (event.touches.length > 1) {
          if (touchTimer) {
            clearTimeout(touchTimer);
            touchTimer = null;
          }
          return;
        }

        if (touchTimer) {
          clearTimeout(touchTimer);
        }

        const touchEvent = event;
        touchTimer = setTimeout(async () => {
          if (touchEvent.touches.length === 1) {
            const rect = event.target.getBoundingClientRect();
            var pt = {
              x: touchEvent.touches[0].clientX - rect.left,
              y: touchEvent.touches[0].clientY - rect.top,
              z: 0,
            };

            // 屏幕转文档坐标;
            var wdCoord = rlAppObj._rlMx.MxFun.screenCoord2Doc(
              pt.x,
              pt.y,
              pt.z
            );
            // 文档坐标转cad坐标
            var cadCoord = rlAppObj._rlMx.MxFun.docCoord2Cad(wdCoord);
            cadCoord = enableSnapCorrection(cadCoord);

            if (sketchCanvasListener) {
              sketchCanvasListener.removeEventListener(
                "touchstart",
                touchHandler
              );
              if (
                store.state.inspectionStore.currentSketchType == "DrawSketch" &&
                classTypeName == "rlAxisC"
              ) {
                await drawAxisSketch(cadCoord);
              }
            }
          }
          touchTimer = null;
        }, 50);
      };

      // 为后续操作添加监听器
      sketchCanvasListener = document.getElementById("container");
      sketchCanvasListener.addEventListener("touchstart", touchHandler);
    } else {
      // PC模式下直接调用lineDraw
      await drawAxisSketch();
    }
  }

  currSketchDataObj = null;
};

let sketchTouchStartHandlerRef = null;
let sketchCanvasListener = null;

export const removeSketchInputTouchListener = () => {
  if (sketchTouchStartHandlerRef) {
    sketchCanvasListener.removeEventListener(
      "touchstart",
      sketchTouchStartHandlerRef
    );
    sketchTouchStartHandlerRef = null;
  }
  sketchCanvasListener = null;
};

// 设置提示语
export const setSketchInputPlaceholder = (textX, textY) => {
  if (sketchInputLabelX && sketchInputLabelY) {
    sketchInputLabelX.textContent = textX;
    sketchInputLabelX.style.display = "block"; // 显示X坐标label

    sketchInputLabelY.textContent = textY;
    sketchInputLabelY.style.display = "block"; // 显示Y坐标label

    // 如果设置了提示语但输入框是隐藏的，可能需要检查一下
    if (!isSketchInputElementVisible && sketchInputContainer) {
      console.log("警告: 设置了提示语但输入框当前是隐藏状态");
    }
  }
};
